import { validationMessages } from '../../utils/validationMessages';

const registrationFormModel = {
  formId: 'RegistrationForm',
  registrationDetailsFormField: {
    IMCNumber: {
      name: 'IMCNumber',
      label: 'IMC number*',
      minStringCount: 6,
      maxStringCount: 6,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get minErrorMessage(): string {
        return `${this.label.replace('*', '')} must be at least 6 digits.`;
      },
      get maxErrorMessage(): string {
        return `${this.label.replace('*', '')} must be no more than ${this.maxStringCount} digits.`;
      }
    },
    RegistrationType: {
      name: 'RegistrationType',
      label: 'Registration type*',
      enrol_information_text: 'Select appropriate Medical Council registration type from drop down list',
      reenrol_information_text: `Select appropriate Medical Council registration type from drop down list 
              (this may have changed from your previous enrolment).`,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    Scheme: {
      name: 'Scheme',
      label: 'Scheme*',
      information_text: 'Please select appropriate PCS scheme from drop down list.',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    EngagedInPracticeOfMedicine: {
      name: 'EngagedInPracticeOfMedicine',
      label: 'Engaged in practice of medicine*',
      information_text: <>
        Indicate whether you are engaged or not engaged in the practice of medicine for this
        registration period.
        <br></br><br></br>
        Engagement in the practice of medicine incorporates activities including:
        <ul>
          <li>Involvement in the act of diagnosing, treating, or managing patient illnesses
            and medical conditions</li>
          <li>Provision of medical advice</li>
          <li>Prescription of medications</li>
          <li>Performing of medical procedures</li>
          <li>Development of preventative programmes</li>
          <li>Conducting relevant medical education or research</li>
          <li>Taking any other actions which require medical knowledge and skills</li>
        </ul>

        If you have any queries, then please contact your Postgraduate Training Body or Further
        information on Professional Competence Guidelines can be found on relevant schemes website.
      </>,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
    },
    UserConfirmation: {
      name: 'UserConfirmation',
      label: 'I confirm that my engagement in practice of medicine status is correct. I wish to proceed with my application and will notifiy the PCS office of any changes to this status.*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    Specialty: {
      name: 'Specialty',
      label: 'Specialty*',
      information_text: 'Please select the specialty you are currently working in.',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    SubSpecialty: {
      name: 'SubSpecialty',
      label: 'Sub specialty',
      maxStringCount: 100,
      information_text: 'Please indicate sub-specialty (if relevant).',
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    }
  },
  personalDetailsFormField: {
    Title: {
      name: 'Title',
      label: 'Title*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    FirstName: {
      name: 'FirstName',
      label: 'First name*',
      maxStringCount: 71,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    LastName: {
      name: 'LastName',
      label: 'Last name*',
      maxStringCount: 171,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    DOB: {
      name: 'DOB',
      label: 'DOB*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get invalidErrorMsg(): string {
        return validationMessages.invalid(this.label);
      },
      get typeError(): string {
        return validationMessages.invalid(this.label);
      }
    },
    Gender: {
      name: 'Gender',
      label: 'Gender*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    Nationality: {
      name: 'Nationality',
      label: 'Nationality*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    MobileNumber: {
      name: 'MobileNumber',
      label: 'Mobile number*',
      maxStringCount: 69,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    }
  },
  educationalDetailsFormField: {
    QualificationCountry: {
      name: 'QualificationCountry',
      label: 'Qualification country*',
      information_text: 'Country where you obtained your primary medical degree.',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    PrimaryMedicalDegreeCollege: {
      name: 'PrimaryMedicalDegreeCollege',
      label: 'University or College (Primary medical) degree*',
      information_text: 'University or College where you obtained your primary medical degree.',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    OtherPrimaryMedicalDegreeCollege: {
      name: 'OtherPrimaryMedicalDegreeCollege',
      label: 'Other University or College (Primary medical) degree*',
      maxStringCount: 300,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    QualificationYear: {
      name: 'QualificationYear',
      label: 'Qualification year*',
      information_text: 'Qualification year you obtained your Primary Medical Degree.',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    }
  },
  workDetailsFormField: {
    StartDate: {
      name: 'StartDate',
      label: 'Start date*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get minimumStartDateErrorMsg(): string {
        return `${this.label.replace('*', '')} must be after the latest work post start date.`;
      },
      get maximumStartDateErrorMsg(): string {
        return `${this.label.replace('*', '')} must be on or before today.`;
      }
    },
    PostLevel: {
      name: 'PostLevel',
      label: 'Post level*',
      information_text: 'Please select the level of your post from the drop down list.',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    Country: {
      name: 'Country',
      label: 'Country*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    NameOfEmployer: {
      name: 'NameOfEmployer',
      label: 'Name of employer*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    OtherNameOfEmployer: {
      name: 'OtherNameOfEmployer',
      label: 'Other (Name of employer)*',
      maxStringCount: 400,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    NameOfClinicalSupervisor: {
      name: 'NameOfClinicalSupervisor',
      label: 'Name of clinical supervisor (if applicable)',
      maxStringCount: 150,
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    JobTitle: {
      name: 'JobTitle',
      label: 'Job title*',
      maxStringCount: 300,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    CurrentUserRoles: {
      name: 'CurrentUserRoles'
    },
    UserRoles: {
      name: 'UserRoles'
    },
    IsThisYourCurrentPost: {
      name: 'IsThisYourCurrentPost',
      label: 'Is this your current post?',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    }
  },
  paymentDetailsFormField: {
    NameOnCard: {
      name: 'nameOnCard',
      label: 'Name on card',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    CardNumber: {
      name: 'cardNumber',
      label: 'Card number',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get invalidErrorMsg(): string {
        return `${this.label.replace('*', '')} is not valid (e.g. 4111111111111).`;
      }
    },
    ExpiryDate: {
      name: 'expiryDate',
      label: 'Expiry date',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get invalidErrorMsg(): string {
        return validationMessages.invalid(this.label);
      }
    },
    CVV: {
      name: 'CVV',
      label: 'CVV',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      digitLengthErrorMessage: 'Must be exactly 3 digits',
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get invalidErrorMsg(): string {
        return `${this.label.replace('*', '')} is invalid (e.g. 357).`;
      }
    },
    SaveCard: {
      name: 'saveCard',
      label: 'Remember credit card details for next time'
    }
  }
};

export default registrationFormModel;
